<!-- 图文导航 -->
<template>
    <div
        v-if="componentsData.type == 1"
        class="bg-div"
        :style="
            componentsData.content.version
                ? {
                      ...(componentsData.content.bg_color && {
                          backgroundColor: componentsData.content.bg_color,
                      }),
                      ...(componentsData.content.bg_img.picview &&
                          componentsData.content.bg_value && {
                              backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                          }),
                      padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                      margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                      borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                  }
                : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
        "
    >
        <div
            v-if="
                componentsData.content.type_id == 2 &&
                componentsData.content.type_value == 2
            "
        >
            <div
                v-if="componentsData.content.iconList[0].title"
                class="card-header"
                :class="{
                    'center-layout':
                        componentsData.content.iconList.length <= 3,
                }"
                :style="{
                    backgroundImage: componentsData.content.nav_img
                        ? `url(${componentsData.content.nav_img.picview})`
                        : 'none',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center center',
                    backgroundRepeat: 'no-repeat',
                }"
            >
                <div
                    v-for="(item, index) of componentsData.content.iconList"
                    :key="index"
                    class="card-content"
                    :style="index == 0 ? firstItemStyle : otherItemsStyle"
                >
                    {{ item.title }}
                </div>
            </div>
            <template v-if="componentsData.content.iconList[0].action_id == 4">
                <div
                    v-if="componentsData.content.iconList[0].clerk"
                    class="clerk-div"
                    :style="`font-size: ${componentsData.content.clerk_size}px; color: ${componentsData.content.clerk_color};`"
                >
                    {{ componentsData.content.iconList[0].clerk }}
                </div>
                <div
                    v-if="componentsData.content.iconList[0].imgList[0].picview"
                    class="card-img"
                >
                    <div
                        v-for="(item, index) of componentsData.content
                            .iconList[0].imgList"
                        :key="index"
                        class="report-div"
                    >
                        <img :src="item.picview" alt="" class="report-img" />
                    </div>
                </div>
            </template>
        </div>
        <div
            v-else
            :class="
                componentsData.content.iconList.length > 1
                    ? 'flex-sb'
                    : 'flex-c'
            "
            class="overflow-hidden"
        >
            <div
                class="icon-div"
                v-for="(item, index) of componentsData.content.iconList"
                :key="index"
            >
                <img
                    v-if="
                        componentsData.content.type_id == 1 ||
                        componentsData.content.type_id == 3
                    "
                    :src="item.picview"
                    class="wh50"
                />
                <div
                    class="fw-bold"
                    :style="`color: ${componentsData.content.title_color};`"
                    v-if="
                        componentsData.content.type_id == 1 ||
                        componentsData.content.type_id == 2
                    "
                >
                    {{ item.title }}
                </div>
                <div
                    class="txt"
                    v-if="
                        componentsData.content.type_id == 1 ||
                        componentsData.content.type_id == 2
                    "
                    :style="`color: ${componentsData.content.text_color};`"
                >
                    {{ item.describe }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        firstItemStyle() {
            return {
                color: this.componentsData.content.txt_color_active,
                backgroundImage: `url(${this.componentsData.content.active_img.picview})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                fontSize: this.componentsData.content.txt_size + "px",
            };
        },
        otherItemsStyle() {
            return {
                color: this.componentsData.content.txt_color,
                fontSize: this.componentsData.content.txt_size + "px",
            };
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    font-size: 15px;
}
.txt {
    font-size: 15px;
}
.icon-div {
    width: 33.333%;
    text-align: center;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.wh50 {
    width: 50px;
    height: 50px;
}
.card-header {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    border-radius: 4px;
    overflow: hidden;
}
.center-layout {
    justify-content: center;
}
.card-content {
    padding: 12px 0;
    text-align: center;
    min-width: 33.333%;
    white-space: nowrap;
}
.card-img {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    margin: 12px 24px 0 24px;
    padding-bottom: 24px;
}
.report-div {
    min-width: 120px;
    width: 120px;
    max-width: 120px;
    height: 185px;
    margin-right: 6px;
}
.report-div:last-child {
    min-width: 120px;
    width: 120px;
    max-width: 120px;
    height: 185px;
    margin-right: 0;
}
.report-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.clerk-div {
    margin: 24px 24px 0 24px;
}
</style>